"use client";

import { useTranslations } from "next-intl";
import ContactForm from "@/components/forms/contact.form";
import { Box, Typography } from "@/components/controls/base-controls";
import { WEBPAGE_CORE_CONTAINER } from "@/core/constants/webpages";

const ContactFeature = () => {
	const t = useTranslations();

	return (
		<Box
			sx={{
				backgroundColor: "var(--mui-palette-page-bg)",
				display: "grid",					
				gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
				gap: 2,
				margin: "0 auto",
				padding: { xs: "2em 1em", md: "3em 1em 2.5em" },
				width: WEBPAGE_CORE_CONTAINER,
				maxWidth: "100%",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDIrection: "column",
					alignItems: "flex-start",
					justifyContent: "center",
				}}
			>
				<Typography
					variant="body1"
					sx={{
						color: "var(--mui-palette-darkest)",
						width: { xs: "100%", md: "24em" },
						maxWidth: "100%",
					}}
				>
					{t("contact.feature.text")}
				</Typography>
			</Box>

			<ContactForm />
		</Box>
	);
};

export default ContactFeature;
